
import BaseButton from '@/components/Common/BaseButton/BaseButton.vue';

export default {
  components: {
    BaseButton,
  },
};
